import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Urls } from 'src/app/_core/constants/Urls';
import Utils from 'src/app/_core/helpers/Utils';
import { UUIDName } from 'src/app/_core/models/GenericObject';
import { SmartAdminGroupUnit } from '../../view-group.model';
import { ToastrMessages } from '../../../../../../../_core/constants/ToastrMessages';
import { ToastrService } from 'ngx-toastr';
import { Clipboard } from '@angular/cdk/clipboard';

@Component({
  selector: 'app-view-group-about-info',
  templateUrl: './view-group-about-info.component.html',
  styleUrls: ['./view-group-about-info.component.scss'],
})
export class ViewGroupAboutInfoComponent implements OnInit {
  //TODO change this variable name to unit
  @Input() group: SmartAdminGroupUnit;
  @Input() companySizes: UUIDName[];
  viewedByFacilitator: boolean;

  // prettier-ignore
  constructor(private router: Router, private clipboard: Clipboard, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.viewedByFacilitator = this.router.url.indexOf(Urls.GROUPS_I_LEAD) > -1;
  }

  openLink(): void {
    Utils.navigate(this.group.meetingLink);
  }

  copyShortcode(text: string): void {
    this.clipboard.copy(text);
    this.toastr.success(...ToastrMessages.COPIED_TO_CLIPBOARD);
  }
}
